import { StringUtil } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";
import { Dialog, DialogProps, Panel } from "@mcleod/components";

/**
 * This class exists to define the basic structure to which all specialty editors must conform.
 */
export abstract class SpecialtyPropertyEditor extends Panel {
    private dialog: Dialog;

    getDialogProps(): Partial<DialogProps> {
        const result: Partial<DialogProps>  = { height: 600, width: 620, title: this.getTitle() };
        if (!StringUtil.isEmptyString(this.getLocalStorageKey())) {
            result.resizable = true;
            result.localStorageKey = this.getLocalStorageKey();
        }
        return result;
    }

    public async show(): Promise<void> {
        await this.showAsDialog();
    }

    public async showAsDialog(adhocDialogProps?: Partial<DialogProps>): Promise<Dialog> {
        this.dialog = await CommonDialogs.showDialog(this, { ...this.getDialogProps(), ...adhocDialogProps});
        return this.dialog;
    }

    public get wasCancelled(): boolean {
        return this.dialog?.wasCancelled === true;
    }

    protected abstract getTitle(): string;
    public abstract getResultValue(): any;

    // Lets the editor be resizable by default, and uses the class name as the local storage key
    protected getLocalStorageKey(): string {
        return this.constructor.name;
    }

    public getDisplayValue(): any {
        return this.getResultValue();
    }

    public doAfterResultApplied(): void {
    }
}
